module.exports = __webpack_public_path__ + "static/sing-unburied-sing-b769728e3f4a6dec6dc2350e533d8ff5.jpg";